<template>
  <div>
    <validation-form @on-submit="updateFormSubtask">
      <div class="md-layout">
        <div class="md-layout-item md-size-33">
          <validation-field
            :validations="{ required: true }"
            name="Task's name"
          >
            <label>{{ $t("task_management.task_name") }}</label>
            <md-input
              :disabled="isDisable"
              v-model.trim="form.task_name"
              required
            ></md-input>
          </validation-field>
        </div>
        <div class="md-layout-item md-size-33" v-if="hasStatus">
          <validation-field :validations="{ required: true }" name="Status">
            <label>{{ $t("common.status") }}</label>
            <md-select
              v-model="form.task_status_id"
              required
              :disabled="disableStatus"
            >
              <md-option
                v-for="status in filterStatus(form.task_status_id)"
                :key="status.name"
                :value="status.id"
              >
                {{ generateStatus(status.name) }}
              </md-option>
            </md-select>
          </validation-field>
        </div>
        <div class="md-layout-item md-size-33">
          <validation-field
            :validations="{ required: true }"
            name="Deadline"
            type="date-picker"
          >
            <template #default="{ errors }">
              <date-picker-custom
                :disabled="isDisable"
                :disabledDate="disabledDate"
                :label="$t('task_management.deadline')"
                v-model="form.deadline"
                required
              >
                <span class="md-error">{{ errors[0] }}</span>
              </date-picker-custom>
            </template>
          </validation-field>
        </div>
        <div class="md-layout-item md-size-33">
          <validation-field
            :validations="{ required: true }"
            name="Assignee"
            type="multi-select"
            v-if="type === 'sub-task' && mode === 'add'"
          >
            <template #default="{ errors }">
              <label class="checkbox-label">
                {{ $t("task_management.assignee") }}
                <span style="color:#F44336">*</span>
              </label>
              <checkbox-multi-select
                :isDisabled="isDisable"
                :options="assignee.assignList"
                trackBy="id"
                displayField="name"
                v-model="form.assignee_id_no_sql"
                :style="{ marginTop: '-6px' }"
                :class="{ 'md-invalid': !!errors.length }"
                @filtering="
                  debounceSearchKey({
                    full_name_or_staff_code: $event.text
                  })
                "
                @select="selectItem"
                @open="fetchStaff({ limit: 50 })"
                @removed="removedItem"
              >
              </checkbox-multi-select>
              <span class="md-error assignee-required">{{ errors[0] }}</span>
            </template>
          </validation-field>
          <validation-field
            style="margin-bottom: 0px !important"
            :validations="{ required: true }"
            name="Assignee"
            type="autocomplete"
            v-else
          >
            <template #default="{ errors }">
              <isis-autocomplete
                :isDisabled="isDisable"
                v-model="assignee.value"
                :value.sync="form.assignee_id_no_sql"
                :options.sync="assignee.assignList"
                :refetchOptions="fetchStaff"
                search-key="full_name_or_staff_code"
                :fields="{ text: 'name', value: 'id' }"
                label="task_management.assignee"
                :class="{ 'md-invalid': !!errors.length }"
                required
                fetchOnOpen
              >
                <span class="md-error" style="top:36px">{{ errors[0] }}</span>
              </isis-autocomplete>
            </template>
          </validation-field>
        </div>
        <div class="md-layout-item md-size-33">
          <isis-autocomplete
            :isDisabled="isDisable"
            v-model="reviewer.value"
            :value.sync="form.reviewer_id_no_sql"
            :options.sync="reviewer.reviewerList"
            :refetchOptions="fetchStaff"
            search-key="full_name_or_staff_code"
            :fields="{ text: 'name', value: 'id' }"
            label="task_management.reviewer"
            fetchOnOpen
          >
          </isis-autocomplete>
        </div>
        <div class="md-layout-item md-size-33" v-if="type === 'individual'">
          <validation-field
            :validations="{ required: true }"
            name="Owner"
            type="autocomplete"
          >
            <template #default="{ errors }">
              <isis-autocomplete
                :isDisabled="isDisable"
                v-model="owner.value"
                :value.sync="form.owner_id_no_sql"
                :options.sync="owner.ownerList"
                :refetchOptions="fetchOwner"
                search-key="search_key"
                :fields="{ text: 'name', value: 'id' }"
                label="task_management.owner"
                :class="{ 'md-invalid': !!errors.length }"
                required
                fetchOnOpen
              >
                <span class="md-error" style="top:36px">{{ errors[0] }}</span>
              </isis-autocomplete>
            </template>
          </validation-field>
        </div>
        <div class="md-layout-item md-size-100 mb-4">
          <md-field class="p-0" v-if="!isDisable">
            <label>{{ $t("behavior.upload_file") }}</label>
            <md-file
              @md-change="upLoadFile($event)"
              :disabled="isDisable"
            ></md-file>
          </md-field>
          <p v-if="mode === 'edit' && form.file" class="break-all">
            {{ $t("task_management.attach_file") }} :
            <a :href="form.download">{{
              form.file.slice(form.file.lastIndexOf("/") + 1)
            }}</a>
          </p>
        </div>
        <div class="md-layout-item md-size-100">
          <p class="text-medium">{{ $t("common.description") }}</p>
          <Editor
            :disabled="isDisable"
            class="md-layout"
            :placeholder="$t('communication.please_enter_content')"
            v-model="form.description"
            :api-key="EDITOR_API_KEY"
            :init="initEditor"
          />
        </div>
        <div class="form-item md-layout-item md-size-100 my-4">
          <div class="form-actions text-center">
            <md-button class="md-raised" @click="goToPreviousPage()">{{
              $t("common.cancel")
            }}</md-button>
            <md-button
              type="submit"
              class="md-success ml-4"
              v-if="allowAddTask"
              :disabled="waitingUpload"
              >{{
                mode === "add" ? $t("common.add_new") : $t("common.update")
              }}</md-button
            >
            <md-button
              class="md-warning"
              @click="rejectTask"
              v-if="userInfo._id === taskReviewer && statusName === 'done'"
              >{{ $t("submitted_report.reject") }}</md-button
            >
            <md-button
              class="md-success"
              @click="approveTask"
              v-if="userInfo._id === taskReviewer && statusName === 'done'"
              >{{ $t("submitted_report.approve") }}</md-button
            >
          </div>
        </div>
      </div>
    </validation-form>
    <div class="md-layout" v-if="mode === 'edit' && type === 'individual'">
      <div class="md-layout-item md-size-100">
        <Comment taskType="individual" :taskId="taskId"></Comment>
      </div>
    </div>
  </div>
</template>
<script>
import { EDITOR_API_KEY, EDITOR_PLUGINS, EDITOR_TOOLBAR } from "./utils";
import Editor from "@tinymce/tinymce-vue";
import moment from "moment";
import { postFileToS3 } from "@/helpers/aws-s3";
import AWSConst from "@/constants/AWS";
import { service_names } from "@/constants/Services";
import {
  getId,
  capitalizeFirstLetter,
  Message,
  hasHistory
} from "@/helpers/utils";
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import { mapGetters } from "vuex";
import Comment from "./Comment";
import debounce from "lodash/debounce";
import { generateStatus } from "../../../helpers/text-helper";
import cloneDeep from "lodash/cloneDeep";

const roleActive = localStorage.getItem("roleActive");

export default {
  props: ["type", "mode", "mainTaskId", "ownerId", "subtaskData"],
  components: {
    Editor,
    CheckboxMultiSelect,
    Comment
  },
  data() {
    return {
      generateStatus,
      capitalizeFirstLetter,
      EDITOR_TOOLBAR,
      EDITOR_PLUGINS,
      EDITOR_API_KEY,
      initEditor: {
        height: 200,
        menubar: true,
        plugins: EDITOR_PLUGINS,
        toolbar: EDITOR_TOOLBAR
      },
      test: "",
      serverValidations: {},
      form: {
        task_name: "",
        task_status_id: "",
        deadline: moment().format("YYYY-MM-DD"),
        assignee_id_no_sql: "",
        reviewer_id_no_sql: "",
        owner_id_no_sql: "",
        description: "",
        file: ""
      },
      statusList: [],
      assignee: {
        value: "",
        assignList: []
      },
      reviewer: {
        value: "",
        reviewerList: []
      },
      owner: {
        value: "",
        ownerList: []
      },
      selectedAssignee: [],
      taskStatus: {},
      statusName: "",
      taskOwner: "",
      taskReviewer: "",
      taskAssignee: "",
      hasStatus: false,
      waitingUpload: false
    };
  },
  created() {
    let initData = async () => {
      await this.fetchStatus();
      if (this.mode === "add" && roleActive !== "Teacher") {
        this.owner.value = this.userInfo.full_name;
        this.owner.value = `${this.userInfo.full_name || ""} - ${this.userInfo
          .staff_code || ""}`;
        this.form.owner_id_no_sql = getId(this.userInfo);
      }
      if (this.mode === "edit") this.setForm(this.subtaskData);
    };
    initData();
  },
  watch: {
    "form.deadline": function() {
      this.serverValidations.deadline && delete this.serverValidations.deadline;
    }
  },
  computed: {
    ...mapGetters("user", { userInfo: "info" }),
    taskId() {
      return this.$route.params.id;
    },
    isDisable() {
      return (
        this.mode === "edit" &&
        (this.statusName !== "assigned" ||
          (this.taskOwner !== this.userInfo._id &&
            roleActive !== "Admin" &&
            roleActive !== "Principal"))
      );
    },
    allowAddTask() {
      return (
        ((this.userInfo._id === this.taskOwner ||
          this.userInfo._id === this.taskAssignee ||
          roleActive === "Admin" ||
          roleActive === "Principal") &&
          this.mode === "edit") ||
        this.mode === "add"
      );
    },
    disableStatus() {
      return (
        this.mode === "edit" &&
        this.taskOwner !== this.userInfo._id &&
        this.taskAssignee !== this.userInfo._id &&
        roleActive !== "Admin" &&
        roleActive === "Principal"
      );
    },
    debounceSearchKey() {
      return debounce(function(param) {
        this.fetchStaff(param);
      }, 500);
    }
  },
  methods: {
    setForm(taskData) {
      this.statusName = taskData.sub_task_status?.name;
      this.taskOwner = taskData.owner_id_no_sql;
      this.taskReviewer = taskData.reviewer_id_no_sql;
      this.taskAssignee = taskData.assignee_id_no_sql;
      this.assignee.value = this.renderStaffName(taskData.assignee_sub_tasks);
      this.reviewer.value = this.renderStaffName(taskData.reviewer_sub_tasks);
      this.owner.value = this.renderStaffName(taskData.owner_sub_tasks);

      this.form.task_name = taskData.task_name;
      this.form.task_status_id = taskData.task_status_id;
      this.form.deadline = moment(taskData.deadline).format("YYYY-MM-DD");
      this.form.assignee_id_no_sql = taskData.assignee_id_no_sql;
      this.form.reviewer_id_no_sql = taskData.reviewer_id_no_sql;
      this.form.description = taskData.description;
      this.form.file = taskData.file;
      this.form.download = taskData.download_file;
      this.form.owner_id_no_sql = taskData.owner_id_no_sql;
    },
    disabledDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    goToPreviousPage() {
      hasHistory()
        ? this.$router.go(-1)
        : this.$router.push("/task-management");
    },
    async upLoadFile(e) {
      this.waitingUpload = true;
      this.form.file = await this.uploadFileToS3(this.changeFileName(e[0]));
      this.waitingUpload = false;
    },
    changeFileName(file) {
      return new File([file], file.name.replace("-", "_").replace(" ", ""), {
        type: file.type
      });
    },
    uploadFileToS3(file) {
      return postFileToS3(AWSConst.S3_TASK_MANAGEMENT_UPLOAD_PATH, file);
    },
    fetchStatus() {
      return this.$axios
        .get(`${service_names.school}/task-status`)
        .then(res => {
          for (let i = 0; i < res.data.data.length; i++) {
            this.taskStatus[res.data.data[i].name] = res.data.data[i];
          }
          this.hasStatus = true;
          this.form.task_status_id = this.taskStatus.assigned?.id;
        });
    },
    addIndividualTask() {
      this.$axios
        .post(`${service_names.school}/task-individual`, this.form)
        .then(res => {
          Message.success(this.$t("task_management.add_successfully"));
          this.$router.replace({ path: "/task-management" });
        });
    },
    editIndividualTask() {
      this.$axios
        .patch(
          `${service_names.school}/task-individual/${this.taskId}`,
          this.form
        )
        .then(() => {
          Message.success(this.$t("common.update_success"));
          this.$router.replace({ path: "/task-management" });
        });
    },
    addSubTask() {
      let data = {
        ...this.form,
        owner_id_no_sql: this.ownerId,
        main_task_id: this.mainTaskId
      };
      data.assignee_ids_no_sql = data.assignee_id_no_sql;
      delete data.assignee_id_no_sql;
      this.$axios
        .post(`${service_names.school}/task-managements/sub-task`, data)
        .then(res => {
          Message.success(this.$t("task_management.add_successfully"));
          this.$emit("addSubtaskSuccessfully");
        });
    },
    editSubTask() {
      this.$axios
        .patch(
          `${service_names.school}/sub-task/${this.subtaskData.id}`,
          this.form
        )
        .then(() => {
          Message.success(this.$t("common.update_success"));
          this.goToPreviousPage();
        });
    },
    updateFormSubtask() {
      if (this.mode === "add") {
        if (this.type === "individual") {
          this.addIndividualTask();
        }
        if (this.type === "sub-task") {
          this.addSubTask();
        }
      }
      if (this.mode === "edit") {
        if (this.type === "individual") {
          this.editIndividualTask();
        }
        if (this.type === "sub-task") {
          this.editSubTask();
        }
      }
    },
    rejectTask() {
      this.reviewerManageTask(this.taskStatus["re-open"]?.id);
    },
    approveTask() {
      this.reviewerManageTask(this.taskStatus.closes?.id);
    },
    reviewerManageTask(status) {
      this.form.task_status_id = status;
      if (this.type === "sub-task") {
        this.editSubTask();
      } else {
        this.editIndividualTask();
      }
    },
    renderStaffName(staff) {
      return staff
        ? `${staff.full_name || ""} - ${staff.staff_code || ""}`
        : "";
    },
    fetchStaff(param) {
      this.assignee.assignList = [];
      this.reviewer.reviewerList = [];
      this.owner.ownerList = [];
      if (param) {
        param.limit = 50;
      }
      return this.$axios
        .get(
          `${service_names.user}/staffs`,
          param,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(res => {
          if (res.data.data.length) {
            if (this.mode === "add" && this.type === "sub-task") {
              let assignList = res.data.data
                .filter(
                  item =>
                    item._id !== this.form.reviewer_id_no_sql &&
                    !this.selectedAssignee
                      .map(assignee => getId(assignee))
                      .includes(item._id)
                )
                .map(item => ({
                  id: getId(item),
                  name: this.renderStaffName(item)
                }));
              this.assignee.assignList = [
                ...this.selectedAssignee,
                ...assignList
              ];
              this.form.assignee_id_no_sql = this.selectedAssignee.map(item => {
                return getId(item);
              });
            } else {
              let assignList = res.data.data
                .filter(item => item._id !== this.form.reviewer_id_no_sql)
                .map(item => ({
                  id: getId(item),
                  name: this.renderStaffName(item)
                }));
              this.assignee.assignList = assignList;
            }
            let reviewerList =
              this.type === "sub-task" && this.mode === "add"
                ? res.data.data.filter(
                    item =>
                      !this.selectedAssignee
                        .map(item => {
                          return getId(item);
                        })
                        .includes(item._id)
                  )
                : res.data.data.filter(
                    item => item._id !== this.form.assignee_id_no_sql
                  );
            this.reviewer.reviewerList = reviewerList.map(item => ({
              id: getId(item),
              name: this.renderStaffName(item)
            }));
          }
        });
    },
    fetchOwner(param) {
      return this.$axios
        .get(
          `${service_names.school}/task-managements/owner`,
          param,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(res => {
          this.owner.ownerList = res.data.data.map(item => ({
            id: getId(item),
            name: this.renderStaffName(item)
          }));
        });
    },
    selectItem(event) {
      this.selectedAssignee.push(event.itemData);
      this.form.assignee_id_no_sql = this.selectedAssignee.map(item => {
        return item.id;
      });
    },
    removedItem(event) {
      this.selectedAssignee = this.selectedAssignee.filter(
        item => item.id !== event.itemData?.id
      );
      this.form.assignee_id_no_sql = this.selectedAssignee.map(item => {
        return item.id;
      });
    },
    filterStatus(value) {
      if (
        !value ||
        value === this.taskStatus["assigned"]?.id ||
        value === this.taskStatus["in-progress"]?.id ||
        value === this.taskStatus.done?.id
      ) {
        return [
          this.taskStatus["assigned"],
          this.taskStatus["in-progress"],
          this.taskStatus.done
        ];
      }
      if (value === this.taskStatus["re-open"]?.id) {
        return [
          this.taskStatus["re-open"],
          this.taskStatus["in-progress"],
          this.taskStatus.done
        ];
      }
      if (value === this.taskStatus.closes?.id) {
        return [this.taskStatus.closes];
      }
      return [
        this.taskStatus["assigned"],
        this.taskStatus["in-progress"],
        this.taskStatus.done
      ];
    }
  }
};
</script>
<style scoped lang="scss">
.assignee-required {
  color: #ff1744;
  font-size: 12px;
  top: -4px !important;
  position: relative;
}
.checkbox-label {
  font-size: 11px;
  font-weight: 400;
  color: #aaaaaa !important;
  line-height: 1.4;
}
</style>
